import dayjs from "dayjs";
import { api } from ".";
const now = dayjs();
const basePath = "/weekly-shift";
const dateConvert = (time: number) => {
  const hours = time / 60;
  const minutes = time % 60;
  const date = now
    .set("hour", hours)
    .set("minute", minutes)
    .set("second", 0)
    .set("millisecond", 0);
  return date;
};

export const getWeeklyShifts = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );

    const res = await api.get(`${basePath}`, { params: filteredParams });

    return res;
  } catch (error) {
    return error;
  }
};

export const getWeeklyShiftDetailById = async (id: any) => {
  try {
    const res = await api.get(`${basePath}/${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const createWeeklyShift = async ({ values, companyId }: any) => {
  let days = values.days;

  if (values.days) {
    days.forEach((day: any) => {
      day.startTime = dateConvert(day.startTime).format();
    });
  }

  try {
    const res = await api.post(`${basePath}`, {
      companyId,
      name: values.name,
      code: values.code,
      days: days,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteWeeklyShiftById = async ({ id }: any) => {
  try {
    const res = await api.delete(`${basePath}/${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const updateWeeklyShiftById = async ({ id, values }: any) => {
  let days = values.days;

  if (values.days) {
    days.forEach((day: any) => {
      day.startTime = dateConvert(day.startTime).format();
    });
  }
  try {
    const res = await api.put(`${basePath}/${id}`, {
      name: values.name,
      code: values.code,
      days: days,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getShiftEmployeesOnDate = async ({ shiftId, time }: any) => {
  try {
    const res = await api.post(`${basePath}/getListOfEmployeesOnDate`, {
      shiftId,
      time,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getShiftEmployeesBelongsToShift = async ({
  shiftId,
  startTime,
  endTime,
}: any) => {
  try {
    const res = await api.post(`${basePath}/getListOfEmployeesBelongsToShift`, {
      shiftId,
      startTime,
      endTime,
    });
    return res;
  } catch (error) {
    return error;
  }
};
